// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("icomoon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("icomoon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-pause:before {
  content: "\\e94e";
}
.icon-play1:before {
  content: "\\e94f";
}
.icon-sound-off:before {
  content: "\\e950";
}
.icon-sound-on:before {
  content: "\\e951";
}
.icon-add-player-80:before {
  content: "\\e952";
}
.icon-added-player:before {
  content: "\\e953";
}
.icon-pages-88:before {
  content: "\\e954";
}
.icon-play2:before {
  content: "\\e955";
}
.icon-copy-86:before {
  content: "\\e900";
}
.icon-agency:before {
  content: "\\e901";
}
.icon-bell-59:before {
  content: "\\e902";
}
.icon-check-single-72:before {
  content: "\\e903";
}
.icon-coach:before {
  content: "\\e904";
}
.icon-company:before {
  content: "\\e905";
}
.icon-edit-82:before {
  content: "\\e906";
}
.icon-fan:before {
  content: "\\e907";
}
.icon-goalkeeper-45:before {
  content: "\\e908";
}
.icon-group-friends:before {
  content: "\\e909";
}
.icon-hashtag-73:before {
  content: "\\e90a";
}
.icon-history-71 .path1:before {
  content: "\\e90b";
  color: rgb(255, 255, 255);
}
.icon-history-71 .path2:before {
  content: "\\e90c";
  margin-left: -1em;
  color: rgb(35, 31, 32);
}
.icon-history-71 .path3:before {
  content: "\\e90d";
  margin-left: -1em;
  color: rgb(35, 31, 32);
}
.icon-image-70:before {
  content: "\\e90e";
}
.icon-instagram-80:before {
  content: "\\e90f";
}
.icon-lock-closed:before {
  content: "\\e910";
}
.icon-lock-open:before {
  content: "\\e911";
}
.icon-new-message-81:before {
  content: "\\e912";
}
.icon-phone:before {
  content: "\\e913";
}
.icon-player:before {
  content: "\\e914";
}
.icon-team-2-64:before {
  content: "\\e915";
}
.icon-team:before {
  content: "\\e916";
}
.icon-warining:before {
  content: "\\e917";
}
.icon-web:before {
  content: "\\e918";
}
.icon-whatsapp-79 .path1:before {
  content: "\\e919";
  color: rgb(255, 255, 255);
}
.icon-whatsapp-79 .path2:before {
  content: "\\e91a";
  margin-left: -1em;
  color: rgb(0, 0, 0);
}
.icon-whatsapp-79 .path3:before {
  content: "\\e91b";
  margin-left: -1em;
  color: rgb(0, 0, 0);
}
.icon-whatsapp-79 .path4:before {
  content: "\\e91c";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.icon-wi-fi:before {
  content: "\\e91d";
}
.icon-wi-fi-empty:before {
  content: "\\e91e";
}
.icon-wi-fi-full:before {
  content: "\\e91f";
}
.icon-wi-fi-off:before {
  content: "\\e920";
}
.icon-wistle:before {
  content: "\\e921";
}
.icon-claps-48:before {
  content: "\\e922";
}
.icon-play:before {
  content: "\\e923";
}
.icon-chevron-left:before {
  content: "\\e924";
}
.icon-chevron-down:before {
  content: "\\e925";
}
.icon-chevron-roght:before {
  content: "\\e926";
}
.icon-arrow-left:before {
  content: "\\e927";
}
.icon-arrow-right:before {
  content: "\\e928";
}
.icon-chevron-up:before {
  content: "\\e929";
}
.icon-user:before {
  content: "\\e92a";
}
.icon-settings:before {
  content: "\\e92b";
}
.icon-search:before {
  content: "\\e92c";
}
.icon-new:before {
  content: "\\e92d";
}
.icon-plus:before {
  content: "\\e92e";
}
.icon-minus:before {
  content: "\\e92f";
}
.icon-location:before {
  content: "\\e930";
}
.icon-delete:before {
  content: "\\e931";
}
.icon-x:before {
  content: "\\e932";
}
.icon-email:before {
  content: "\\e933";
}
.icon-home:before {
  content: "\\e934";
}
.icon-mark:before {
  content: "\\e935";
}
.icon-mark-fill:before {
  content: "\\e936";
}
.icon-calendar:before {
  content: "\\e937";
}
.icon-camera:before {
  content: "\\e938";
}
.icon-send-message:before {
  content: "\\e939";
}
.icon-checked:before {
  content: "\\e93a";
}
.icon-message:before {
  content: "\\e93b";
}
.icon-credir-card:before {
  content: "\\e93c";
}
.icon-trash:before {
  content: "\\e93d";
}
.icon-double-check:before {
  content: "\\e93e";
}
.icon-options:before {
  content: "\\e93f";
}
.icon-menu:before {
  content: "\\e940";
}
.icon-favorite-empty:before {
  content: "\\e941";
}
.icon-favourite-full:before {
  content: "\\e942";
}
.icon-ball:before {
  content: "\\e943";
}
.icon-penalty:before {
  content: "\\e944";
}
.icon-free-kick:before {
  content: "\\e945";
}
.icon-sv-corner-kick:before {
  content: "\\e946";
}
.icon-share:before {
  content: "\\e947";
}
.icon-trophy:before {
  content: "\\e948";
}
.icon-sustitution:before {
  content: "\\e949";
}
.icon-arrow-down:before {
  content: "\\e94a";
}
.icon-arrow-up:before {
  content: "\\e94b";
}
.icon-field:before {
  content: "\\e94c";
}
.icon-wistle1:before {
  content: "\\e94d";
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/icons-font.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAwB;EACxB;;;yDAG0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('icomoon.eot');\n  src:  url('icomoon.eot#iefix') format('embedded-opentype'),\n    url('icomoon.ttf') format('truetype'),\n    url('icomoon.woff') format('woff'),\n    url('icomoon.svg#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-pause:before {\n  content: \"\\e94e\";\n}\n.icon-play1:before {\n  content: \"\\e94f\";\n}\n.icon-sound-off:before {\n  content: \"\\e950\";\n}\n.icon-sound-on:before {\n  content: \"\\e951\";\n}\n.icon-add-player-80:before {\n  content: \"\\e952\";\n}\n.icon-added-player:before {\n  content: \"\\e953\";\n}\n.icon-pages-88:before {\n  content: \"\\e954\";\n}\n.icon-play2:before {\n  content: \"\\e955\";\n}\n.icon-copy-86:before {\n  content: \"\\e900\";\n}\n.icon-agency:before {\n  content: \"\\e901\";\n}\n.icon-bell-59:before {\n  content: \"\\e902\";\n}\n.icon-check-single-72:before {\n  content: \"\\e903\";\n}\n.icon-coach:before {\n  content: \"\\e904\";\n}\n.icon-company:before {\n  content: \"\\e905\";\n}\n.icon-edit-82:before {\n  content: \"\\e906\";\n}\n.icon-fan:before {\n  content: \"\\e907\";\n}\n.icon-goalkeeper-45:before {\n  content: \"\\e908\";\n}\n.icon-group-friends:before {\n  content: \"\\e909\";\n}\n.icon-hashtag-73:before {\n  content: \"\\e90a\";\n}\n.icon-history-71 .path1:before {\n  content: \"\\e90b\";\n  color: rgb(255, 255, 255);\n}\n.icon-history-71 .path2:before {\n  content: \"\\e90c\";\n  margin-left: -1em;\n  color: rgb(35, 31, 32);\n}\n.icon-history-71 .path3:before {\n  content: \"\\e90d\";\n  margin-left: -1em;\n  color: rgb(35, 31, 32);\n}\n.icon-image-70:before {\n  content: \"\\e90e\";\n}\n.icon-instagram-80:before {\n  content: \"\\e90f\";\n}\n.icon-lock-closed:before {\n  content: \"\\e910\";\n}\n.icon-lock-open:before {\n  content: \"\\e911\";\n}\n.icon-new-message-81:before {\n  content: \"\\e912\";\n}\n.icon-phone:before {\n  content: \"\\e913\";\n}\n.icon-player:before {\n  content: \"\\e914\";\n}\n.icon-team-2-64:before {\n  content: \"\\e915\";\n}\n.icon-team:before {\n  content: \"\\e916\";\n}\n.icon-warining:before {\n  content: \"\\e917\";\n}\n.icon-web:before {\n  content: \"\\e918\";\n}\n.icon-whatsapp-79 .path1:before {\n  content: \"\\e919\";\n  color: rgb(255, 255, 255);\n}\n.icon-whatsapp-79 .path2:before {\n  content: \"\\e91a\";\n  margin-left: -1em;\n  color: rgb(0, 0, 0);\n}\n.icon-whatsapp-79 .path3:before {\n  content: \"\\e91b\";\n  margin-left: -1em;\n  color: rgb(0, 0, 0);\n}\n.icon-whatsapp-79 .path4:before {\n  content: \"\\e91c\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-wi-fi:before {\n  content: \"\\e91d\";\n}\n.icon-wi-fi-empty:before {\n  content: \"\\e91e\";\n}\n.icon-wi-fi-full:before {\n  content: \"\\e91f\";\n}\n.icon-wi-fi-off:before {\n  content: \"\\e920\";\n}\n.icon-wistle:before {\n  content: \"\\e921\";\n}\n.icon-claps-48:before {\n  content: \"\\e922\";\n}\n.icon-play:before {\n  content: \"\\e923\";\n}\n.icon-chevron-left:before {\n  content: \"\\e924\";\n}\n.icon-chevron-down:before {\n  content: \"\\e925\";\n}\n.icon-chevron-roght:before {\n  content: \"\\e926\";\n}\n.icon-arrow-left:before {\n  content: \"\\e927\";\n}\n.icon-arrow-right:before {\n  content: \"\\e928\";\n}\n.icon-chevron-up:before {\n  content: \"\\e929\";\n}\n.icon-user:before {\n  content: \"\\e92a\";\n}\n.icon-settings:before {\n  content: \"\\e92b\";\n}\n.icon-search:before {\n  content: \"\\e92c\";\n}\n.icon-new:before {\n  content: \"\\e92d\";\n}\n.icon-plus:before {\n  content: \"\\e92e\";\n}\n.icon-minus:before {\n  content: \"\\e92f\";\n}\n.icon-location:before {\n  content: \"\\e930\";\n}\n.icon-delete:before {\n  content: \"\\e931\";\n}\n.icon-x:before {\n  content: \"\\e932\";\n}\n.icon-email:before {\n  content: \"\\e933\";\n}\n.icon-home:before {\n  content: \"\\e934\";\n}\n.icon-mark:before {\n  content: \"\\e935\";\n}\n.icon-mark-fill:before {\n  content: \"\\e936\";\n}\n.icon-calendar:before {\n  content: \"\\e937\";\n}\n.icon-camera:before {\n  content: \"\\e938\";\n}\n.icon-send-message:before {\n  content: \"\\e939\";\n}\n.icon-checked:before {\n  content: \"\\e93a\";\n}\n.icon-message:before {\n  content: \"\\e93b\";\n}\n.icon-credir-card:before {\n  content: \"\\e93c\";\n}\n.icon-trash:before {\n  content: \"\\e93d\";\n}\n.icon-double-check:before {\n  content: \"\\e93e\";\n}\n.icon-options:before {\n  content: \"\\e93f\";\n}\n.icon-menu:before {\n  content: \"\\e940\";\n}\n.icon-favorite-empty:before {\n  content: \"\\e941\";\n}\n.icon-favourite-full:before {\n  content: \"\\e942\";\n}\n.icon-ball:before {\n  content: \"\\e943\";\n}\n.icon-penalty:before {\n  content: \"\\e944\";\n}\n.icon-free-kick:before {\n  content: \"\\e945\";\n}\n.icon-sv-corner-kick:before {\n  content: \"\\e946\";\n}\n.icon-share:before {\n  content: \"\\e947\";\n}\n.icon-trophy:before {\n  content: \"\\e948\";\n}\n.icon-sustitution:before {\n  content: \"\\e949\";\n}\n.icon-arrow-down:before {\n  content: \"\\e94a\";\n}\n.icon-arrow-up:before {\n  content: \"\\e94b\";\n}\n.icon-field:before {\n  content: \"\\e94c\";\n}\n.icon-wistle1:before {\n  content: \"\\e94d\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
